module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image45.be28e095.jpg";